import React from 'react';

import { Table } from '@betterment/samba-react';

type BulkFeeIntentBodyCellProps = React.PropsWithChildren<{
  noWrap?: boolean;
  pr?: boolean;
}>;

export const BulkFeeIntentBodyCell: React.FC<BulkFeeIntentBodyCellProps> = ({
  children,
  noWrap = false,
  pr = false,
}) => (
  <Table.Cell
    css={{
      borderRadius: 'none',
      borderTop: 'solid',
      borderTopColor: 'border.weak',
      py: 'space.300',
      px: '0',
      verticalAlign: 'middle',
      fontSize: 'fontSize.100',
      lineHeight: 'lineHeight.100',
      whiteSpace: noWrap ? 'nowrap' : undefined,
      pr: pr ? 'space.200' : undefined,
    }}
  >
    {children}
  </Table.Cell>
);
